import React, { useEffect, useState } from 'react'
import * as styles from "./styles/imageholder.module.css";
import { Image } from 'semantic-ui-react';

const FALLBACK_IMAGE = "https://cdn.ngnw.ph/logo-product.png";

const ImageHolder = (props) => {
    const {
        imageHolderClassname = "",
        imageLoading = false,
        displayMode = "default",
        loading = "lazy",
        decoding = "async",
        showImage = true,

        src,
        className = "",
        sizes,
        heightToWidthRatio,

        mobileSrc,
        mobileClassName = "",
        mobileSizes,
        mobileHeightToWidthRatio,

        ...imageProps
    } = props;

    // heightToWidthRatio = (Height / Width)
    // Padding Bottom Percentage = heightToWidthRatio * 100
    // E.g. (400 / 500) * 100 = 80%
    const paddingBottomPercentage = {
        "--desktop-paddingBottom": `${(heightToWidthRatio * 100).toFixed(2)}%`,
        // If mobileHeightToWidthRatio is not provided, use heightToWidthRatio instead
        "--mobile-paddingBottom": `${((mobileHeightToWidthRatio ?? heightToWidthRatio) * 100).toFixed(2)}%`
    }

    const getValidSrc = (src) => {
        return typeof src === "string"
            ? src.trim() !== ''
                ? src
                : FALLBACK_IMAGE
            : FALLBACK_IMAGE
    };

    const [imageSrc, setImageSrc] = useState(getValidSrc(src));
    const [imageMobileSrc, setImageMobileSrc] = useState(getValidSrc(mobileSrc));

    const [hasError, setHasError] = useState(false);
    const [hasErrorMobile, setHasErrorMobile] = useState(false);

    useEffect(() => {
        setImageSrc(getValidSrc(src));
        setHasError(false);

        setImageMobileSrc(getValidSrc(mobileSrc));
        setHasErrorMobile(false);
    }, [src, mobileSrc])

    const buildSrcSet = (url, sizes) => {
        if (url !== FALLBACK_IMAGE && sizes !== undefined) {
            if (url.includes("/full/")) {
                // For safety
                const cleanUrl = decodeURI(url);

                let highUrl = cleanUrl.replace("/full/", "/high/");
                let medUrl = cleanUrl.replace("/full/", "/med/");
                let thumbUrl = cleanUrl.replace("/full/", "/thumb/")

                return `${encodeURI(thumbUrl)} 200w, ${encodeURI(medUrl)} 512w, ${encodeURI(highUrl)} 1024w, ${encodeURI(cleanUrl)} 2048w`.trim();
            }
        }

        return undefined;
    }

    let srcSet = buildSrcSet(imageSrc, sizes);
    let mobileSrcSet = buildSrcSet(imageMobileSrc, mobileSizes);

    const handleImageError = (type) => {
        // Prevent infinite loop

        if (!hasError && type === "desktop") {
            setHasError(true);
            setImageSrc(FALLBACK_IMAGE);
        }

        if (!hasErrorMobile && type === "mobile") {
            setHasErrorMobile(true);
            setImageMobileSrc(FALLBACK_IMAGE);
        }
    }

    return (
        <div
            className={`${styles.imageHolder} ${imageHolderClassname} ${mobileSrc !== undefined ? styles.hasMobile : ''}`}
            style={paddingBottomPercentage}
        >
            {/* 
              * Note: Decided not to use the <picture> approach for now. 
              * - Not sure how to implement on determining which src (dekstop or mobile) fails to load 
              * - Conflict when setting 'as' attribute as Link
              */}
            {displayMode === "default" && showImage && <>
                <Image
                    {...imageProps}
                    loading={loading}
                    decoding={decoding}
                    src={imageSrc}
                    {...(srcSet !== undefined ? { srcSet } : {})}
                    sizes={sizes}
                    className={`${styles.desktopImage} ${className} ${hasError ? styles.imageLoading : ''}`}
                    onError={() => handleImageError("desktop")}
                />

                {mobileSrc !== undefined && (
                    <Image
                        {...imageProps}
                        loading={loading}
                        decoding={decoding}
                        src={imageMobileSrc}
                        {...(mobileSrcSet !== undefined ? { srcSet: mobileSrcSet } : {})}
                        sizes={mobileSizes}
                        className={`${styles.mobileImage} ${mobileClassName || className} ${hasErrorMobile ? styles.imageLoading : ''}`}
                        onError={() => handleImageError("mobile")}
                    />
                )}
            </>}

            {displayMode === "loading" &&
                <Image {...imageProps} src="https://cdn.ngnw.ph/loading-square.gif" className={`${className} ${styles.imageLoading}`} />
            }

            {/* other display mode... */}
        </div>
    )
}

export default ImageHolder;